import { useEffect, useRef } from 'react';

interface PendingRedirect {
  returnToStepId: string;
  timestamp: number;
}

export function useRedirectCleanup(
  pendingRedirect: PendingRedirect | null,
  isLoggedIn: boolean,
  clearPendingRedirect: () => void,
) {
  const processedRedirectRef = useRef<string | null>(null);

  useEffect(() => {
    if (!pendingRedirect || !isLoggedIn) {
      return;
    }

    const redirectKey = `${pendingRedirect.returnToStepId}-${pendingRedirect.timestamp}`;

    // prevent clearing the same redirect multiple times
    if (processedRedirectRef.current === redirectKey) {
      return;
    }

    processedRedirectRef.current = redirectKey;

    // Delay clearing to ensure orchestrator has initialized with initialIndex
    setTimeout(() => {
      clearPendingRedirect();
    }, 100);
  }, [pendingRedirect, isLoggedIn, clearPendingRedirect]);
}
